module.exports = __webpack_public_path__ + "9d36245663568de7f05b764e85f2d254.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/ABCMonumentGrotesk-Regular.woff
// module id = 34
// module chunks = 0 1